// Datele afisate public pentru o expozitie (29.1): o expozitie programata (vernisajul inca n-a avut loc)
// se anunta prin „Vernisaj: <zi>, <ora>”; restul - prin data deschiderii, ca inainte.
const ZI = {day: 'numeric', month: 'long', year: 'numeric'};
const ORA = {hour: '2-digit', minute: '2-digit'};

export const formatData = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString('ro-RO', {...ZI, timeZone: 'Europe/Bucharest'});
};

export const formatDataOra = (iso) => {
    if (!iso) return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return null;
    return `${d.toLocaleDateString('ro-RO', {...ZI, timeZone: 'Europe/Bucharest'})}, ${d.toLocaleTimeString('ro-RO', {...ORA, timeZone: 'Europe/Bucharest'})}`;
};

// Eticheta scurta pentru carduri (lista, homepage).
export const etichetaDataExpozitie = (e) => (e?.programata && e.vernisaj
    ? `Vernisaj: ${formatDataOra(e.vernisaj)}`
    : formatData(e?.dataStart) || 'Dată neanunțată');

// „Deschidere pentru public” se mentioneaza doar daca difera de vernisaj.
export const deschidereDiferita = (e) => !!(e?.vernisaj && e?.dataStart && new Date(e.vernisaj).getTime() !== new Date(e.dataStart).getTime());
